import React from "react";
import PatientFormModal from "./PatientFormModal";

interface NewPatientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPatientCreated?: (patient: any) => void;
  context?: string;
  title?: string;
  description?: string;
  /** What was searched before choosing "Add a new patient": fills the name (or the phone, if it's a number) */
  initialSearch?: string;
}

export default function NewPatientModal({
  isOpen,
  onClose,
  onPatientCreated,
  title = "New patient",
  initialSearch,
}: NewPatientModalProps) {
  const handleSuccess = (patient: any, intent: 'patient-only' | 'patient-and-rx') => {
    onPatientCreated?.(patient);
    // Note: intent is handled by the parent PatientFormModal
  };

  return (
    <PatientFormModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={handleSuccess}
      mode="create"
      compact={true}
      title={title}
      showPrescriptionOption={true}
      initialSearch={initialSearch}
    />
  );
}
